import InfoCircleOutlined from '@ant-design/icons';
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Table,
	Tooltip,
	Typography
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { createDayPartSchedule, getDayPartSchedules } from "../../redux/rtk/features/dayPartSchedule/dayPartSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";



function CustomTable({ list, loading }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Full Day Hours",
			dataIndex: "fullDayHours",
			key: "fullDayHours",
		},

		{
			id: 3,
			title: "Half Day Hours",
			dataIndex: "halfDayHours",
			key: "halfDayHours",
		},
		{
			id: 3,
			title: "Short Day",
			dataIndex: "shortLeave",
			key: "shortLeave",
		},

		{
			id: 4,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => <ViewBtn path={`/admin/dayPartSchedule/${id}/`} />,
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Day Part Schedule List
				</h5>
				{list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={list}
								className='btn btn-dark btn-sm mb-1'
								filename='Day-Part-Schedule'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list || loading}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}

const DayPartSchedule = ({ drawer }) => {
	// const { list, loading } = useSelector((state) => state.weeklyHoliday);
	const { list, loading } = useSelector((state) => state.dayPart);

	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getDayPartSchedules());
	}, []);

	const { Title } = Typography;

	const onFinish = async (values) => {
		setLoader(true);

		// Convert fullDayHours and halfDayHours to Float
		const formattedValues = {
			...values,
			fullDayHours: parseFloat(values.fullDayHours),
			halfDayHours: parseFloat(values.halfDayHours),
			shortLeave: parseFloat(values.shortLeave)
		};

		const resp = await dispatch(createDayPartSchedule(formattedValues));

		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(getDayPartSchedules());
		} else {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
	};
	return (
		<Fragment bordered={false}>
			<UserPrivateComponent permission={"create-publicHoliday"}>
				<Row className='mr-top' justify={drawer ? "center" : "space-between"}>
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={drawer ? 22 : 12}
						xl={drawer ? 22 : 12}
						className='column-design border rounded card-custom'>
						{/* <Title level={4} className='m-2 mt-5 mb-5 text-center'>
							Add Day Part Schedule
						</Title> */}

						<div className="text-center m-2 mt-5 mb-5">
							<Title level={4} style={{ display: "inline-block", marginRight: "10px" }}>
								Add Day Part Schedule
							</Title>
							<Tooltip title="Enter minimum working hours of a day to consider as a full day or half day.">
								<InfoCircleOutlined style={{ fontSize: "20px", cursor: "pointer" }} />
							</Tooltip>
						</div>
						<Form
							style={{ marginBottom: "40px" }}
							form={form}
							eventKey='department-form'
							name='basic'
							labelCol={{
								span: 6,
							}}
							wrapperCol={{
								span: 12,
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<div>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Full Day Hours'
									name='fullDayHours'
									rules={[
										{
											required: true,
											message: "Please input Full Day Hours!",
										},
									]}>
									<Input placeholder='Full Day Hours' />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Half Day Hours'
									name='halfDayHours'
									rules={[
										{
											required: true,
											message: "Please input Half Day Hours!",
										},
									]}>
									<Input placeholder='Half Day Hours' />
								</Form.Item>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Short Day'
									name='shortLeave'
								// rules={[
								// 	{
								// 		required: true,
								// 		message: "Please input short leave!",
								// 	},
								// ]}
								>
									<Input placeholder='short leave' />
								</Form.Item>


								<Form.Item
									style={{ marginBottom: "10px" }}
									wrapperCol={{
										offset: 6,
										span: 12,
									}}>
									<Button
										onClick={() => setLoader(true)}
										type='primary'
										size='large'
										htmlType='submit'
										block
										loading={loader}>
										Add
									</Button>
								</Form.Item>
							</div>
						</Form>
					</Col>
				</Row>
			</UserPrivateComponent>
			<hr />
			<UserPrivateComponent permission={"readAll-publicHoliday"}>
				{drawer || <CustomTable list={list} loading={loading} />}
			</UserPrivateComponent>
		</Fragment>
	);
};

export default DayPartSchedule;
